const TRISTATE_SI = 1;
const TRISTATE_NO = 0;
const TRISTATE_CUALQUIERA = 2;

class TriStateUtils {
  static checkBool(triStateVal, b) {
    return (
      (triStateVal === 0 && !b) || (triStateVal === 1 && b) || triStateVal === 2
    );
  }

  static boolToTriState(b) {
    return b ? 1 : 0;
  }
}

export {
  TriStateUtils as default,
  TRISTATE_SI,
  TRISTATE_NO,
  TRISTATE_CUALQUIERA,
};
